module.exports = __webpack_public_path__ + "img/e2c8bfc237a36094297eebb38972eb37.png";